export default function makeFirstLetterCapital(data) {
  return data.charAt(0).toUpperCase() + data.slice(1);
}
